import React from "react";
import '../App.css';


const LoadingScreen: React.FC = () => {
  return (
    <div className="loading-wrapper">
      <div className="loading-card">
        <div className="spinner"></div>
        <h2>Connecting to your remote…</h2>
      </div>
    </div>
  );
};

export default LoadingScreen;
